export default __webpack_public_path__ + "static/media/javascript-01.12c711e7.png";